
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { setIcoData } from '../../../lib/userSessionSlice';
import { lazy, useEffect, useState } from 'react';


export function useGetIco () {
const [status,setStatus] = useState({
    data:null,
    isLoading:false,
    isError:false
})

    const dispatch = useDispatch()
    const setIco = (data) => dispatch(setIcoData(data))

    const getIco = async () => {

        setStatus((prev)=>({
            isLoading:false,
            isError:false
        }))

        let apiBase = process.env.REACT_APP_API_BASE_URL
        let endpoint = `${apiBase + '/ico'}`
        let config = {
             headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "authorization": process.env.REACT_APP_API_KEY
            }, 
        }
        try {
            const icoData = await axios.get(endpoint, config).then((res) => res.data)
            setIco(icoData?.data)
            
        setStatus((prev)=>({
            ...prev,
            isLoading:false,
            data:icoData?.data
        }))
        } catch (error) {

            
        setStatus((prev)=>({
            isLoading:false,
            isError:true,
        }))
            console.error("Error:", error.response?.data || error.message);
        }
    }

    useEffect(() => {
        const controller = new AbortController(); // Create a new AbortController
        const signal = controller.signal;
        getIco(signal)
        return () => {
            controller.abort(); // Cleanup function to cancel the request on unmount
        };
    }, [])


return status


}